import { graphql } from '@/src/graphql';

export const Viewer = graphql(`
  query ViewerDetails($teamId: ID) {
    viewer {
      _id
      _default_team
      displayName
      intercomJWT
      ConnectedTeam(teamId: $teamId) {
        _id
        name
        settings {
          auto_record_rooms
        }
      }
      meta {
        identity {
          firstname
          lastname
        }
      }
      contact {
        phone {
          mobile
        }
      }
      kinde_user_id
      Teams {
        _id
        name
        kinde_org_id
      }
      email
      type {
        participant
        client
        researcher
      }
      settings {
        language
      }
    }
  }
`);
